import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import range from 'lodash/range';

import starFilled from '../../images/star-filled.svg';
import starEmpty from '../../images/star-empty.svg';

const Stars = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const StarContainer = styled.span`
  display: inline-block;
  width: ${(props) => props.starWidth}px;
  height: ${(props) => props.starHeight}px;
  background: url(${(props) => props.isActive ? starFilled : starEmpty}) no-repeat 0 0;
  background-size: contain;

  & + & {
    margin-left: 4px;
  }
`;

const StarRatingStatic = ({
  starsAmount = 5, width, height, activeStarIdx,
}) => {
  const roundedActiveStarIdx = Math.round(activeStarIdx);

  return (
    <Stars>
      {range(starsAmount).map((i) => (
        <StarContainer
          key={i}
          isActive={i + 1 <= roundedActiveStarIdx}
          starWidth={width}
          starHeight={height}
        />
      ))}
    </Stars>
  );
};

StarRatingStatic.propTypes = {
  activeStarIdx: PropTypes.number,
  starsAmount: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};

StarRatingStatic.defaultProps = {
  starsAmount: 5,
  activeStarIdx: 0,
  width: 33,
  height: 30,
};

export { StarRatingStatic };
